import { ChevronLeft, RotateCw, X } from 'lucide-react'
import React from 'react'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { cn } from '../../lib/utils';
import { isMobile } from 'react-device-detect';

const ChatbotHeader = ({ chatConfigurationStyle, setIsOpen, businessId, setShowHome }) => {

  const handleReset = () => {
    localStorage.removeItem(businessId);
    window.location.reload()
  }
  return (
    <div className='rounded-t-lg py-5 px-4 flex justify-between items-center chatbot-header text-primary-foreground'>
      <div className='flex items-center gap-2'>
        {/* <div className='bg-white w-[40px] h-[40px] rounded-full'>
          <img className='object-contain w-full h-full' src={`${process.env.REACT_APP_S3_BASE_URL}/${chatConfigurationStyle?.profile}`} />
        </div> */}
        <ChevronLeft size={22} onClick={() => setShowHome(true)} className='cursor-pointer' />
        <h2 className='text-[16px] font-semibold'>{chatConfigurationStyle?.displayName}</h2>
      </div>
      <div className='flex items-center gap-3'>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger>
              <RotateCw onClick={handleReset} className='500:w-5 500:h-5 w-4 h-4 cursor-pointer ml-3' />

            </TooltipTrigger>
            <TooltipContent>Start over</TooltipContent>
          </Tooltip>
        </TooltipProvider>
        <X onClick={() => setIsOpen(false)} className={cn('w-5 h-5 cursor-pointer hidden text-white',isMobile && "block")} />
      </div>
    </div>
  )
}

export default ChatbotHeader